import React, {Fragment} from 'react'
import {formatTime} from 'admin/lib/format'
import Details from './Details'

const EVENT_MAP = {
  create: 'Created',
  destroy: 'Deleted',
  restore: 'Restored'
}

export default ({history}) => {
  return (
    <table className={`table is-striped is-fullwidth`}>
      <colgroup>
        <col span='1' style={{width: '25%'}} />
        <col span='1' style={{width: '75%'}} />
      </colgroup>
      <tbody className='is-size-7'>
        {history.map((version, i) => {
          return (
            <tr key={i}>
              <td style={{lineHeight: '1.5em', padding: '1em'}}>
                {formatTime(version.timestamp)}
                <br />
                <span className='has-text-weight-semibold'>{version.user || 'System'}</span>
              </td>
              <td style={{lineHeight: '1.3em', padding: '1em'}}>
                {!['associate', 'update'].includes(version.event) ? (
                  <Fragment>
                    {EVENT_MAP[version.event]}
                    <br />
                  </Fragment>
                ) : null}
                {version.notes?.length ? (
                  <Fragment>
                    <span className={version.user ? 'has-text-info has-text-weight-semibold' : ''}>
                      {version.notes}
                    </span>
                    <br />
                  </Fragment>
                ) : null}
                <Details details={version.details} />
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
